import { runtimeConfig } from '@/shared/config'
import { initObservability } from '@/shared/observability'

// Bootstrap до рендера: Sentry/web-vitals (условно), MSW в mock-режиме (dynamic
// import → tree-shake в проде). i18n нет — интерфейс ru-only.
export async function bootstrap(): Promise<void> {
  initObservability()

  if (runtimeConfig.API_MODE === 'mock') {
    const { startMockWorker } = await import('@/shared/api')
    await startMockWorker()
  }
}
